
import { Box } from '@mui/material';
import '../../App.css';
import { BackgroundStyle, ListContainer, HeadingTitle } from '../../assets/style';
import MainContent from '../../components/MainContent';
import { mapPageName } from '../../components/PageName';
import { useTranslation } from "react-i18next";
import MapView from '../../components/MapView';

const MapPage = () => {
    const {t} = useTranslation();

    return (
        <MainContent type={mapPageName}>
            <Box sx={{ bgcolor: '#456296' }}>
                <HeadingTitle>{t("Map")}</HeadingTitle>
            </Box>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer>
                    {/* <Box sx={{
                        display: 'flex', flexDirection: 'column', width: '100', padding: 2
                    }}> */}
                        <Box sx={{
                            display: 'flex', height: '45%', gap: '20px',
                            "@media (max-width: 800px)": { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }
                        }}>
                            <MapView />
                        </Box>
                        <Box sx={{
                            display: 'flex', height: '45%', marginTop: '10px', gap: '20px',
                            "@media (max-width: 800px)": { display: 'flex', flexDirection: 'column', marginLeft: "0px", width: '100%', height: '100%' }
                        }}>
                        </Box>
                    {/* </Box> */}
                </ListContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default MapPage;